import { Component } from '@angular/core';
import { OngletlayoutComponent } from "../../../components/layouts/ongletlayout/ongletlayout.component";
import { routeAlias } from '../../../../routesalias';
import { RouterOutlet } from '@angular/router';
import { closeLocalStorage } from '../../../utils/helpers';

@Component({
  selector: 'app-parametres',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './parametres.component.html',
  styleUrl: './parametres.component.css'
})
export class ParametresLayout {
  tableLinkForParameters = [
    {
      text: "Activités",
      link: routeAlias.parameters.activity.home,
    },
    {
      text: "Marchés",
      link: routeAlias.parameters.marches.home,
    },
    {
      text: "Comptabilités",
      link: routeAlias.parameters.comptabilites.home,
    },
    {
      text: "Postes",
      link: routeAlias.parameters.poste.home,
    },
  ]

  onCloseLocalStorage(): void {
    closeLocalStorage();
  }
}
